import { AdFormData } from '../ads/components/Ad/contracts';
import { ArticleCarouselFormData } from '../article/components/ArticleCarousel/contracts';
import { ArticleHighlightedCardFormData } from '../article/components/ArticleHighlightedCard/contracts';
import { ArticleListFormData } from '../article/components/ArticleList/contracts';
import { FeaturedTagsFormData } from '../article/components/FeaturedTags/contracts';
import { NewsletterSubscribeFormData } from '../article/components/NewsletterSubscribe/contracts';
import { RichTextPreviewFormData } from '../article/components/RichTextEditor/contracts';
import { LinkFormData } from '../common/components/Link/contracts';
import { FixtureListFormData } from '../fixtures/components/FixtureList/contracts';
import { ContactsListFormData } from '../league/components/ContactsList/contracts';
import { LeagueTableFormData } from '../league/components/LeagueTable/contracts';
import { SocialNetworksFormData } from '../league/components/SocialNetworks/contracts';
import { SponsorCardFormData } from '../league/components/SponsorCard/contracts';
import { SponsorsGridFormData } from '../league/components/SponsorsGrid/contracts';
import { ClubListFormData } from '../league/components/ClubList/contracts';
import { TeamListFormData } from '../league/components/TeamList/contracts';
import { FaqFormData } from '../faq/components/Faq/contracts';
import { ContactUsFormData } from '@ui/common/components/ContactUs/contracts';
import { TabsFormData } from '../tabs/components/Tabs/contracts';
import { VideoListFormData } from '../video/components/VideoList/contracts';
import { VideoCarouselFormData } from '../video/components/VideoCarousel/contracts';

export enum CmsComponent {
  ArticleCarousel = 'ArticleCarousel',
  ArticleHighlightedCard = 'ArticleHighlightedCard',
  ArticleList = 'ArticleList',
  RichTextPreview = 'RichTextPreview',
  NewsletterSubscribe = 'NewsletterSubscribe',
  LeagueTable = 'LeagueTable',
  FixtureList = 'FixtureList',
  ClubList = 'ClubList',
  TeamList = 'TeamList',
  SocialNetworks = 'SocialNetworks',
  SponsorCard = 'SponsorCard',
  SponsorsGrid = 'SponsorsGrid',
  Ad = 'Ad',
  FeaturedTags = 'FeaturedTags',
  Link = 'Link',
  ContactsList = 'ContactsList',
  Faq = 'Faq',
  ContactUs = 'ContactUs',
  Tabs = 'Tabs',
  VideoList = 'VideoList',
  VideoCarousel = 'VideoCarousel',
}

type ArticleCarouselData = {
  id: string;
  type: CmsComponent.ArticleCarousel;
  data: ArticleCarouselFormData;
};

type ArticleHighlightedCardData = {
  id: string;
  type: CmsComponent.ArticleHighlightedCard;
  data: ArticleHighlightedCardFormData;
};

type ArticleListData = {
  id: string;
  type: CmsComponent.ArticleList;
  data: ArticleListFormData;
};

type RichTextPreviewData = {
  id: string;
  type: CmsComponent.RichTextPreview;
  data: RichTextPreviewFormData;
};

type NewsletterSubscribeData = {
  id: string;
  type: CmsComponent.NewsletterSubscribe;
  data: NewsletterSubscribeFormData;
};

type LeagueTableData = {
  id: string;
  type: CmsComponent.LeagueTable;
  data: LeagueTableFormData;
};

type ClubListData = {
  id: string;
  type: CmsComponent.ClubList;
  data: ClubListFormData;
};

type TeamListData = {
  id: string;
  type: CmsComponent.TeamList;
  data: TeamListFormData;
};

type FixtureListData = {
  id: string;
  type: CmsComponent.FixtureList;
  data: FixtureListFormData;
};

type SocialNetworksData = {
  id: string;
  type: CmsComponent.SocialNetworks;
  data: SocialNetworksFormData;
};

type SponsorCardData = {
  id: string;
  type: CmsComponent.SponsorCard;
  data: SponsorCardFormData;
};

type SponsorsGridData = {
  id: string;
  type: CmsComponent.SponsorsGrid;
  data: SponsorsGridFormData;
};

type AdData = {
  id: string;
  type: CmsComponent.Ad;
  data: AdFormData;
};

type FeaturedTagsData = {
  id: string;
  type: CmsComponent.FeaturedTags;
  data: FeaturedTagsFormData;
};

type LinkData = {
  id: string;
  type: CmsComponent.Link;
  data: LinkFormData;
};

type ContactsListData = {
  id: string;
  type: CmsComponent.ContactsList;
  data: ContactsListFormData;
};

type FaqData = {
  id: string;
  type: CmsComponent.Faq;
  data: FaqFormData;
};

type ContactUsData = {
  id: string;
  type: CmsComponent.ContactUs;
  data: ContactUsFormData;
};

type TabsData = {
  id: string;
  type: CmsComponent.Tabs;
  data: TabsFormData;
};

type VideoListData = {
  id: string;
  type: CmsComponent.VideoList;
  data: VideoListFormData;
};

type VideoCarouselData = {
  id: string;
  type: CmsComponent.VideoCarousel;
  data: VideoCarouselFormData;
};

export type ComponentData =
  | ArticleCarouselData
  | ArticleHighlightedCardData
  | ArticleListData
  | RichTextPreviewData
  | NewsletterSubscribeData
  | LeagueTableData
  | FixtureListData
  | ClubListData
  | TeamListData
  | SocialNetworksData
  | SponsorCardData
  | SponsorsGridData
  | AdData
  | FeaturedTagsData
  | LinkData
  | ContactsListData
  | FaqData
  | ContactUsData
  | TabsData
  | VideoListData
  | VideoCarouselData;
